<template>
  <div>
    <a-modal v-drag-modal wrap-class-name="custom-modal-wrap" :bodyStyle="{ padding: '16px', overflow: 'hidden' }"
      v-model="localVisible" :confirmLoading="loading" :maskClosable="false" @cancel="cancel" @ok="confirm">
      <div slot="title">{{ form.id ? "编辑" : "新增" }}</div>
      <div style="max-height: 60vh; overflow-y: auto;">
        <a-form-model ref="form" :model="form" :rules="rules" :label-col="{ span: 6 }" :wrapper-col="{ span: 16 }">
          <a-form-model-item prop="name" :label="isRawMaterial ? '原料名称' : '产品名称'">
            <a-select
              v-model="form.name"
              style="width: 100%"
              :show-search="true"
              :filterOption="false"
              @change="handleChange"
              @search="handleSearch"
              @popupScroll="handlePopupScroll"
            >
              <a-select-option v-for="val in filteredProductList" :key="val.id" :value="val.name + '-' + val.id">
                {{ val.name }} ({{ val.id }})
              </a-select-option>
              <a-select-option v-if="isLoadingMore" disabled key="loading">
                <a-spin size="small" /> 加载中...
              </a-select-option>
              <a-select-option v-if="!hasMore && allLoadedData.length > 0" disabled key="no-more">
                已加载全部 {{ totalCount }} 条数据
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <!-- <a-form-model-item prop="product_brand" label="产品品牌">
            <a-input v-model="form.product_brand" />
          </a-form-model-item> -->
          <a-form-model-item prop="sales_area" label="销售区域">
            <a-input v-model="form.sales_area" />
          </a-form-model-item>
          <!-- <a-form-model-item prop="product_type" label="产品类型">
            <a-input v-model="form.product_type" />
          </a-form-model-item>
          <a-form-model-item prop="standards" label="执行标准">
            <a-input v-model="form.standards" />
          </a-form-model-item>
          <a-form-model-item prop="period" label="产品保质期">
            <a-input v-model="form.period" />
          </a-form-model-item> -->
          <a-form-model-item prop="commpany" label="生产企业">
            <a-textarea v-model="form.commpany" />
          </a-form-model-item>
          <a-form-model-item prop="adreess" label="生产地址">
            <a-textarea v-model="form.adreess" />
          </a-form-model-item>
          <a-form-model-item prop="introduce" label="产品介绍">
            <a-input v-model="form.introduce" />
          </a-form-model-item>
          <a-form-model-item prop="net_content" label="净含量">
            <a-input v-model="form.net_content" />
          </a-form-model-item>
          <a-form-model-item prop="net_content" label="贮存条件">
            <a-input v-model="form.hoarding" />
          </a-form-model-item>
          <a-form-model-item prop="remark" label="联系方式">
            <a-input v-model="form.remark" />
          </a-form-model-item>
          <!-- <a-form-model-item prop="bar_code" label="条形码">
            <a-input v-model="form.bar_code" />
          </a-form-model-item> -->
          <a-form-model-item prop="licence_no" label="许可证编号">
            <a-input v-model="form.licence_no" allowClear />
          </a-form-model-item>
          <a-form-model-item prop="ingredients" label="配料表">
            <a-textarea v-model="form.ingredients" allowClear :autoSize="{ minRows: 5, maxRows: 9 }" />
          </a-form-model-item>
        </a-form-model>
      </div>
    </a-modal>
  </div>
</template>

<script>
import { goodsInformationList } from "@/api/goods";
import { fromProductAdd, fromProductEdit } from "@/api/from";

export default {
  name: "FormModal",
  props: {
    visible: Boolean,
    oform: Object,
    clientsClassificationOptions: Array,
    isRawMaterial: {
      type: Boolean,
      default: false // false=产品, true=原料
    }
  },
  model: { prop: "visible", event: "cancel" },
  data() {
    return {
      localVisible: this.visible,
      form: {},
      productList: [],
      levelOptions: [
        { id: "0", name: "0" },
        { id: "1", name: "1" },
        { id: "2", name: "2" },
        { id: "3", name: "3" },
      ],
      rules: {
        name: [
          { required: true, message: "请选择产品名称", trigger: "change" },
        ],
        /* product_specs: [
            { required: true, message: "请输入产品规格", trigger: "blur" }
          ],
          product_brand: [
            { required: true, message: "请输入产品品牌", trigger: "blur" }
          ], */
        sales_area: [
          { required: true, message: "请输入销售区域", trigger: "blur" },
        ],
        /* product_type: [
            { required: true, message: "请输入产品类型", trigger: "blur" }
          ],
          standards: [
            { required: true, message: "请输入执行标准", trigger: "blur" }
          ],
          period: [
            { required: true, message: "请输入产品保质期", trigger: "blur" }
          ], */
        commpany: [
          { required: true, message: "请输入生产企业", trigger: "blur" },
        ],
        adreess: [
          { required: true, message: "请输入生产地址", trigger: "blur" },
        ],
      },
      loading: false,
      currentPage: 1,
      pageSize: 50,
      totalCount: 0,
      hasMore: true,
      searchKeyword: '',
      localSearchKeyword: '', // 本地搜索关键词
      isLoadingMore: false,
      allLoadedData: [], // 已加载的全量数据
    };
  },
    watch: {
      visible(val) {
        this.localVisible = val;
      },
      localVisible(val) {
        if (!val) {
          this.$emit('cancel', false);
        }
      }
    },
  created() {
    this.loadMoreData();
    if (this.oform) {
      this.form = { ...this.oform }
    }
  },
  methods: {
    /**
     * 加载更多数据(不传搜索关键词,获取全量数据)
     * @param {boolean} isLoadMore - 是否为滚动加载更多
     */
    loadMoreData(isLoadMore = false) {
      // 新加载则重置分页
      if (!isLoadMore) {
        this.currentPage = 1;
        this.allLoadedData = [];
      }
      
      const types = this.isRawMaterial ? 'material' : 'product';
      this.isLoadingMore = true;
      
      // 不传product_kw参数,获取全量数据
      goodsInformationList({ 
        page: this.currentPage, 
        page_size: this.pageSize,
        types 
      }).then(res => {
        const newList = res.results || [];
        this.totalCount = res.count || 0;
        
        // 追加到全量数据
        if (isLoadMore) {
          this.allLoadedData = [...this.allLoadedData, ...newList];
        } else {
          this.allLoadedData = newList;
        }
        
        // 判断是否还有更多数据
        this.hasMore = this.allLoadedData.length < this.totalCount;
      }).finally(() => {
        this.isLoadingMore = false;
      });
    },
    /**
     * 用户输入搜索关键词时,更新本地搜索状态
     */
    handleSearch(value) {
      this.localSearchKeyword = value;
    },
    /**
     * 下拉框滚动到底部时加载更多数据
     */
    handlePopupScroll(e) {
      const { target } = e;
      const scrollHeight = target.scrollHeight;
      const scrollTop = target.scrollTop;
      const clientHeight = target.clientHeight;
      
      // 滚动到底部且还有更多数据且不在加载中
      if (scrollHeight - scrollTop <= clientHeight + 10 && this.hasMore && !this.isLoadingMore) {
        this.currentPage++;
        this.loadMoreData(true);
      }
    },
    handleChange(val) {
      // console.log(val);
      //this.form.name = val
      // console.log(this.form.name);
      this.form.product_name = val.replace(/-\d+$/, '');
      this.form.product_id = val.split('-').pop();
    },
    confirm() {
      this.$refs.form.validate((valid) => {
        if (valid) {
          this.loading = true;
          let func = this.form.id ? fromProductEdit : fromProductAdd;
          func(this.form)
            .then((res) => {
              if (res.code === 200 || res.code === 0) {
                this.$message.success(this.form.id ? "修改成功" : "新增成功");
                this.$emit(this.form.id ? "update" : "create");
                this.cancel();
              } else {
                this.$message.error(res.message)
              }
            })
            .finally(() => {
              this.loading = false;
            });
        }
      });
    },
    cancel() {
      this.$emit("cancel", false);
      if (!this.form.id) {
        this.$refs.form.resetFields();
      }
    },
  },
  computed: {
    filteredProductList() {
      let list = this.allLoadedData;
      
      // 1. 根据类型过滤 (产品/原料)
      const targetType = this.isRawMaterial ? 'material' : 'product';
      list = list.filter(p => p.types === targetType);
      
      // 2. 根据本地搜索关键词过滤
      if (this.localSearchKeyword) {
        const keyword = this.localSearchKeyword.toLowerCase();
        list = list.filter(item => {
          const nameStr = (item.name || '').toLowerCase();
          const idStr = String(item.id || '').toLowerCase();
          return nameStr.includes(keyword) || idStr.includes(keyword);
        });
      }
      
      return list;
    }
  },
};
</script>

<style scoped></style>
